import { FocusPayEntityType } from "../enums/focuspay-entity-type.enum";
import { FocusPayMerchantTitles } from "../enums/focuspay-merchant-contact-type";
import { FocusPayProcessingRateType } from "../enums/focuspay-processing-rate-type.enum";
import { FocuspayState } from "../enums/focuspay-state-enum";
import { InfiniceptBoardingResult, InfiniceptUnderwritingResult } from "./Infinicept-MerchantApplication-dto";

export class FocusPayApplication {
	pk: string; //focuspay_application
	sk: string; //inviteKey
	dealerKey: string;
	dealerLogoS3Key: string;

	accountNameDba: string = undefined;
	entityType: FocusPayEntityType = undefined;
	estimatedAverageTicket: number;
	estimatedVolume: number;
	legalAddress: MerchantAddress = new MerchantAddress(); //DONE
	legalBusinessName: string = undefined;
	merchantAddress: MerchantAddress = new MerchantAddress(); //DONE
	merchantBanking: MerchantBanking = new MerchantBanking();
	merchantContacts: MerchantContact[] = [];
	merchantEmail: string = undefined;
	merchantName: string; //done
	merchantPhone: string = undefined;
	merchantBusinessType: number;
	processingRates: MerchantRates = new MerchantRates();
	productSold: string = "Food & Beverage"; //not applicable
	partnerApplicationId: string; //Infinicept applicationid
	partnerId: number; //Id property from Infinicept
	taxId: string = undefined;
	website: string; //done
	yearsInBusiness: number = undefined;
	yearsOfCurrentOwnership: number; //done

	partnerApplicationStatus: number;
	partnerApplicationStatusLabel: string;

	partnerUnderwritingResults: InfiniceptUnderwritingResult[];
	partnerBoardingResults: InfiniceptBoardingResult[];

	public constructor(init?: Partial<FocusPayApplication>) {
		Object.assign(this, init);
	}
}

export class MerchantAddress {
	street: string = undefined;
	street2: string;
	city: FocuspayState = undefined;
	state: string = undefined;
	postalCode: string = undefined;
	country: string = "US";

	public constructor(init?: Partial<MerchantAddress>) {
		Object.assign(this, init);
	}
}

export class MerchantContact {
	firstName: string;
	middleInitial: string;
	lastName: string;
	title: FocusPayMerchantTitles;
	phone: string;
	email: string;
	contactType: string;
	socialSecurityNumber: string;
	dateOfBirth: Date;
	ownershipPercentage?: number;
	address: MerchantAddress;
	isOwner: boolean;
	isPoc: boolean;
	isSigner: boolean;

	public constructor(init?: Partial<MerchantContact>) {
		Object.assign(this, init);
	}
}

export class MerchantBanking {
	bankName: string;
	routingNumber: string = undefined;
	accountNumber: string = undefined;

	public constructor(init?: Partial<MerchantBanking>) {
		Object.assign(this, init);
	}
}

export class MerchantRates {
	type: FocusPayProcessingRateType = FocusPayProcessingRateType.FLATRATE;
	interchangeBinSponsorship: number = 2.6;
	interchangeTransaction: number = 0.1;
	amexBinSponsorship: number = 2.8;
	amexTransaction: number = 0.1;
	voiceAuthFee: number = 0.25;
	chargebackFee: number = 25.0;
	nsfFee: number = 25.0;
	statementFee: number = 10.0;
	deviceInsuranceFee: number = 7.5;
	batchFee: number = 0.5;
	retrievalRequestFee: number = 25.0;
	annualFee: number = 0.0;
	faasFee: number = 50.0;
	dealerSupportFee: number = 2500.0;

	public constructor(init?: Partial<MerchantRates>) {
		Object.assign(this, init);
	}
}
